import { useSelector } from 'react-redux';

export const useLocalizedText = key =>
  useSelector(state => state.pagesRedux[state.language]?.[key] || '');
